<template>
  <main class="admin container">
      Users
  </main>
</template>

<script>


export default {
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>
